import dynamic from "next/dynamic";

export const DynamicContent053 = dynamic(() => import("./Content053"), {
  suspense: true,
});
